// extracted by mini-css-extract-plugin
module.exports = {"houses-card-layout":"housesCard_houses-card-layout__JvK_z","image":"housesCard_image__srhCe","empty-state":"housesCard_empty-state__PruKf"};